import { addDoc, collection, serverTimestamp } from 'firebase/firestore';

export const getAcquisitionContext = () => {
  if (typeof window === 'undefined') return {};
  const params = new URLSearchParams(window.location.search);
  const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const utm = keys.reduce((result, key) => {
    const value = params.get(key);
    if (value) result[key] = value.slice(0, 200);
    return result;
  }, {});
  return {
    ...utm,
    landingPage: `${window.location.pathname}${window.location.search}`.slice(0, 500),
    referrer: document.referrer ? document.referrer.slice(0, 500) : '',
  };
};

export const recordAdminJourneyEvent = async (db, { eventName, userId = null, email = '', source = '', projectId = '', projectName = '', details = {} }) => {
  if (!eventName) return;
  try {
    const event = {
      eventName,
      userId: userId || null,
      email: email || '',
      source: source || 'unknown',
      projectId: projectId || '',
      projectName: projectName || '',
      details,
      createdAt: serverTimestamp(),
    };
    if (userId) {
      event.acquisition = getAcquisitionContext();
    }
    await addDoc(collection(db, 'adminAnalyticsEvents'), event);
  } catch (error) {
    console.warn('Could not record admin journey event:', eventName, error);
  }
};
